import React from "react";
import PropTypes from "prop-types";
import styles from "./InfoTab.module.css";

const IBO_LINK_SHAPE = PropTypes.exact({
  name: PropTypes.string.isRequired,
  iboNumber: PropTypes.string.isRequired,
});

const MEMBER_SHAPE = PropTypes.exact({
  name: PropTypes.string.isRequired,
  iboNumber: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  topicsId: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
});

function DisplayLink({ label, data, onClick }) {
  return (
    <div className={styles.uplineRow}>
      <span className={styles.uplineLabel}>{label}</span>
      <button
        type="button"
        className={styles.uplineLink}
        onClick={() => onClick(data.iboNumber)}
      >
        {data.name || "N/A"}
      </button>
    </div>
  );
}

DisplayLink.propTypes = {
  label: PropTypes.string.isRequired,
  data: IBO_LINK_SHAPE.isRequired,
  onClick: PropTypes.func.isRequired,
};

function MemberBlock({ member }) {
  return (
    <div className={styles.memberBlock}>
      <div className={styles.memberLabels}>
        <div>Name:</div>
        <div>IBO #:</div>
        <div>Phone:</div>
        <div>Topics ID:</div>
        <div>Email:</div>
      </div>

      <div className={styles.memberValues}>
        <div>{member.name || "N/A"}</div>
        <div>{member.iboNumber || "N/A"}</div>
        <div>{member.phone || "N/A"}</div>
        <div>{member.topicsId || "N/A"}</div>
        <div>{member.email || "N/A"}</div>
      </div>
    </div>
  );
}

MemberBlock.propTypes = {
  member: MEMBER_SHAPE.isRequired,
};

export function InfoTab({
  sponsor,
  platinum,
  members,
  onSponsorClick,
  onPlatinumClick,
}) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h3 className={styles.title}>IBO Information</h3>
        <div className={styles.divider} />

        <div className={styles.uplineSection}>
          <DisplayLink
            label="Sponsor:"
            data={sponsor}
            onClick={onSponsorClick}
          />
          <DisplayLink
            label="Platinum:"
            data={platinum}
            onClick={onPlatinumClick}
          />
        </div>

        <div className={styles.divider} />

        <div className={styles.membersSection}>
          {members.map((member, index) => (
            <MemberBlock
              key={`${member.iboNumber || member.name || "member"}-${index}`}
              member={member}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

InfoTab.propTypes = {
  sponsor: IBO_LINK_SHAPE.isRequired,
  platinum: IBO_LINK_SHAPE.isRequired,
  members: PropTypes.arrayOf(MEMBER_SHAPE).isRequired,
  onSponsorClick: PropTypes.func.isRequired,
  onPlatinumClick: PropTypes.func.isRequired,
};
